module.exports = __webpack_public_path__ + "img/17-1.e10219e9.png";